module.exports = __webpack_public_path__ + "static/media/fyn.b6def91c.png";